<template>
    
    <div class="container-fluid">
        <div class="row d-flex justify-content-between align-items-center screen-height">
            <div class="col d-flex justify-content-center">
                <img src="../../assets/main-screen/buttons.png" usemap="#image-map" width="800">
                <map name="image-map">
                    <area @click="$emit('go-to-event', 'VideoScreenId')" class="cursor-pointer" alt="Percorso Multimediale" title="Percorso Multimediale" href="#" coords="1,139 233,12 233,12 379,160 398,230 384,278 360,307 230,179 1,178 " shape="polygon">
                    <area @click="$emit('go-to-event', 'InfoScreenId')" class="cursor-pointer" alt="Presentazione Prodotto" title="Presentazione Prodotto" href="#" coords="446,264 411,195 435,109 499,50 585,130 794,133 799,198 672,198 672,140 581,133 " shape="polygon">
                    <area @click="$emit('go-to-event', 'PathSelectionScreenId')" class="cursor-pointer" alt="Strumento di calcolo" title="Strumento di calcolo" href="#" coords="129,353 128,332 379,329 448,268 581,137 595,142 615,198 611,264 568,316 327,548 295,504 301,418 360,352 " shape="polygon">
                </map>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SelectionScreen',
        emits: ['go-to-event', 'go-back-event'],
        props: {
            previousScreen: '',
        }
    }
</script>